export const FirstContainer = [

    {
        id: 1,
        title: "Hotel Standard 2077",
        img: "https://www.tourism.gov.np//images/publication_images/315.jpg",
        p: "Hotel Standard 2077",
        p1: "22.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 2,
        title: "NEPAL TOURISM STATISTICS 2020",
        img: "https://www.tourism.gov.np//images/publication_images/316.jpg",
        p: "Hotel Standard 2077", p1: "25.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 3,
        title: "Nepal Homestay Contact Directory- BY Taragoon",
        img: "https://www.tourism.gov.np//images/publication_images/317.jpg",
        p: "Hotel Standard 2077",
        p1: "32.32 MB",
        download: "DOWNLOAD"
    },
];


export const SecondContainer = [
    {
        id: 1,
        title: "Moctra",
        img: "https://www.tourism.gov.np//images/publication_images/310.JPG",
        p: "Hotel Standard 2077",
        p1: "42.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 2,
        title: "NEPAL TOURISM STATISTICS 2020",
        img: "https://www.tourism.gov.np//images/publication_images/319.jpg",
        p: "Hotel Standard 2077",
        p1: "28.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 3,
        title: "NEPAL TOURISM STATISTICS 2020",
        img: "https://www.tourism.gov.np//images/publication_images/320.jpg",
        p: "Hotel Standard 2077",
        p1: "32.32 MB",
        download: "DOWNLOAD"
    },
];

export const ThirdContainer = [
    {
        id: 1,
        title: "नेपाल पर्यटन तथा होटेल ब्यबस्थापन  प्रतिष्ठान कर्मचारी सेवा शर्त नियमवलि २०६१",
        img: "https://www.tourism.gov.np//images/publication_images/306.jpg",
        p1: "42.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 2,
        title: "NEPAL TOURISM STATISTICS 2020",
        img: "https://www.tourism.gov.np//images/publication_images/322.jpg",
        p: "Hotel Standard 2077",
        p1: "28.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 3,
        title: "नेपाल पर्यटन तथा होटेल ब्यबस्थापन प्रतिष्ठान आर्थिक प्रसाशन  नियमावली २०६३",
        img: "https://www.tourism.gov.np//images/publication_images/323.jpg",
        p: "Hotel Standard 2077",
        p1: "32.32 MB",
        download: "DOWNLOAD"
    },
];

export const FourthContainer = [
    {
        id: 1,
        title: "सार्बजनिक निकायका पदाधिकारी तथा सदस्यको नियुक्ति र मनोनयन सम्बन्धि मापदण्ड २०७३",
        img: "https://www.tourism.gov.np//images/publication_images/305.png",
        p: "Hotel Standard 2077",
        p1: "42.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 2,
        title: "NEPAL TOURISM STATISTICS 2020",
        img: "https://www.tourism.gov.np//images/publication_images/325.jpg",
        p: "Hotel Standard 2077",
        p1: "28.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 3,
        title: "NEPAL TOURISM STATISTICS 2020",
        img: "https://www.tourism.gov.np//images/publication_images/326.jpg",
        p: "Hotel Standard 2077",
        p1: "32.32 MB",
        download: "DOWNLOAD"
    },
];

export var FifthContainer = [
    {
        id: 1,
        title: "पर्यटन पूर्वाधार तथा पर्यटन उपज विकास साझेदारी (सञ्चालन तथा व्यवस्थापन) निर्देशिका, २०७७",
        img: "https://www.tourism.gov.np//images/publication_images/305.png",
        p: "Hotel Standard 2077",
        p1: "42.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 2,
        title: "सम्पत्ति शुद्धीकरण तथा आतंकबादी कृयाकलापमा बित्तीय लगानी निवारण सम्बन्धमा क्यासिनो व्यवसायीलाइ जारी गरिएको निर्देशन, २०७६",
        img: "https://www.tourism.gov.np//images/publication_images/328.jpg",
        p: "Hotel Standard 2077",
        p1: "28.32 MB",
        download: "DOWNLOAD"
    },
    {
        id: 3,
        title: "NEPAL TOURISM STATISTICS 2020",
        img: "https://www.tourism.gov.np//images/publication_images/286.jpg",
        p: "Hotel Standard 2077",
        p1: "32.32 MB",
        download: "DOWNLOAD",
    },
];
